import { render } from "./FilterPopover.vue?vue&type=template&id=0f8ed9aa&scoped=true"
import script from "./FilterPopover.vue?vue&type=script&lang=js"
export * from "./FilterPopover.vue?vue&type=script&lang=js"

import "./FilterPopover.vue?vue&type=style&index=0&id=0f8ed9aa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0f8ed9aa"

export default script